import makeBossMutation from "@saleor/hooks/makeBossMutation";
import gql from "graphql-tag";

import {
  BatchStatusBulkApprove,
  BatchStatusBulkApproveVariables
} from "./types/BatchStatusBulkApprove";
import {
  BatchStatusBulkCancel,
  BatchStatusBulkCancelVariables
} from "./types/BatchStatusBulkCancel";
import {
  BatchStatusReject,
  BatchStatusRejectVariables
} from "./types/BatchStatusReject";

const BatchStatusBulkApproveMutation = gql`
  mutation BatchStatusBulkApprove($ids: [ID!]) {
    batchStatusBulkApprove(ids: $ids) {
      count
      batchErrors {
        field
        message
        code
      }
    }
  }
`;

export const useBatchStatusBulkApprove = makeBossMutation<
  BatchStatusBulkApprove,
  BatchStatusBulkApproveVariables
>(BatchStatusBulkApproveMutation);

const BatchStatusBulkCancelMutation = gql`
  mutation BatchStatusBulkCancel($ids: [ID!]) {
    batchStatusBulkCancel(ids: $ids) {
      count
      batchErrors {
        field
        message
        code
      }
    }
  }
`;

export const useBatchStatusBulkCancel = makeBossMutation<
  BatchStatusBulkCancel,
  BatchStatusBulkCancelVariables
>(BatchStatusBulkCancelMutation);

const BatchStatusRejectMutation = gql`
  mutation BatchStatusReject($id: ID!, $remarks: String) {
    batchStatusReject(id: $id, remarks: $remarks) {
      id
      remarks
      batchErrors {
        field
        message
        code
      }
    }
  }
`;

export const useBatchStatusReject = makeBossMutation<
  BatchStatusReject,
  BatchStatusRejectVariables
>(BatchStatusRejectMutation);
